import React from "react";
import { Box, FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import palette from "src/theme/palette";
import HyroField from "@hyro-components/fields/HyroField";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import {
  DEPLOYMENT_FIELDS, DRAFT_EXISTS_MESSAGE, DRAFT_NOT_EXISTS_MESSAGE,
  MIN_REPLICAS_TOOLTIP, MEMORY_TOOLTIP, ERROR_TEXTS as DEPLOYMENT_ERROR_TEXTS
} from "./DeploymentSettings.consts";

const DeploymentSettingsTab = ({ deploymentFieldProps, isDeploymentSubmitting, isReadOnly }) => (
  <Stack direction="column" gap={2}>
    <Stack direction="column" gap="2px">
      <Typography variant="h6">Deployment settings</Typography>
      <Typography variant="body2" color="text.secondary">
        {deploymentFieldProps?.draftExists ? DRAFT_EXISTS_MESSAGE : DRAFT_NOT_EXISTS_MESSAGE}
      </Typography>
    </Stack>

    <Box sx={{ bgcolor: palette.system[0], border: 1, borderColor: palette.grey[200], borderRadius: 1, p: 3 }}>
      <Box sx={{ maxWidth: 552 }}>
        <Stack direction="column" gap="24px">
          <HyroField
            fieldType={FIELD_TYPES.TEXT}
            label={DEPLOYMENT_FIELDS.MIN_REPLICAS.label}
            placeholder={DEPLOYMENT_FIELDS.MIN_REPLICAS.label}
            tooltip={MIN_REPLICAS_TOOLTIP}
            value={deploymentFieldProps?.minReplicas?.value}
            onChange={(val) => {
              if (val === "" || /^\d*$/.test(val)) {
                deploymentFieldProps?.minReplicas?.handleChange(val);
                const numVal = parseInt(val);
                if (val === "") {
                  deploymentFieldProps?.minReplicas?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MIN_REPLICAS_REQUIRED);
                } else if (numVal >= DEPLOYMENT_FIELDS.MIN_REPLICAS.min && numVal <= DEPLOYMENT_FIELDS.MIN_REPLICAS.max) {
                  deploymentFieldProps?.minReplicas?.setErrorText("");
                } else if (numVal < DEPLOYMENT_FIELDS.MIN_REPLICAS.min) {
                  deploymentFieldProps?.minReplicas?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MIN_REPLICAS_MIN);
                } else if (numVal > DEPLOYMENT_FIELDS.MIN_REPLICAS.max) {
                  deploymentFieldProps?.minReplicas?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MIN_REPLICAS_MAX);
                }
              }
            }}
            error={deploymentFieldProps?.minReplicas?.errorText}
            isReadOnly={isDeploymentSubmitting || isReadOnly}
            showTopSection
          />

          <FormControlLabel
            control={
              <Switch
                checked={!!deploymentFieldProps?.forceMinReplicas?.value}
                onChange={(e) => deploymentFieldProps?.forceMinReplicas?.handleChange(e.target.checked)}
                disabled={isDeploymentSubmitting || isReadOnly}
              />
            }
            label={DEPLOYMENT_FIELDS.FORCE_MIN_REPLICAS.label}
          />

          <HyroField
            fieldType={FIELD_TYPES.TEXT}
            label={DEPLOYMENT_FIELDS.MEMORY.label}
            placeholder={DEPLOYMENT_FIELDS.MEMORY.label}
            tooltip={MEMORY_TOOLTIP}
            value={deploymentFieldProps?.memory?.value}
            onChange={(val) => {
              if (val === "" || /^\d*$/.test(val)) {
                deploymentFieldProps?.memory?.handleChange(val);
                const numVal = parseInt(val);
                if (val === "") {
                  deploymentFieldProps?.memory?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MEMORY_REQUIRED);
                } else if (numVal >= DEPLOYMENT_FIELDS.MEMORY.min && numVal <= DEPLOYMENT_FIELDS.MEMORY.max) {
                  deploymentFieldProps?.memory?.setErrorText("");
                } else if (numVal < DEPLOYMENT_FIELDS.MEMORY.min) {
                  deploymentFieldProps?.memory?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MEMORY_MIN);
                } else if (numVal > DEPLOYMENT_FIELDS.MEMORY.max) {
                  deploymentFieldProps?.memory?.setErrorText(DEPLOYMENT_ERROR_TEXTS.MEMORY_MAX);
                }
              }
            }}
            error={deploymentFieldProps?.memory?.errorText}
            isReadOnly={isDeploymentSubmitting || isReadOnly}
            showTopSection
          />

          <HyroField
            fieldType={FIELD_TYPES.TEXT}
            label={DEPLOYMENT_FIELDS.CPU.label}
            value={deploymentFieldProps?.cpu?.value}
            isReadOnly
            isFieldReadOnlyFromSpec
            showTopSection
          />

          <HyroField
            fieldType={FIELD_TYPES.TEXT}
            label={DEPLOYMENT_FIELDS.DEDICATED.label}
            value={deploymentFieldProps?.dedicated?.value}
            isReadOnly
            isFieldReadOnlyFromSpec
            showTopSection
          />
        </Stack>
      </Box>
    </Box>
  </Stack>
);

export default DeploymentSettingsTab;
